import * as React from 'react';
import { useSelector } from 'react-redux';

import { isDiscountMortgageBannerEnabled } from '../../selectors/discountMortgage';
import { DiscountMortgageBannerContainer } from '../DiscountMortgageBannerContainer';
import { BrokerConsultantBannerContainer } from '../BrokerConsultantBannerContainer';
import { NewbuildingPrizeBannerContainer } from '../NewbuildingPrizeBannerContainer';
import { useRotatingBanner } from './useRotatingBanner';

export const BannerContainer = () => {
  const isDiscountMortgageBannerAvailable = useSelector(isDiscountMortgageBannerEnabled);
  const rotatingBanner = useRotatingBanner();

  if (isDiscountMortgageBannerAvailable) {
    return <DiscountMortgageBannerContainer />;
  }

  if (rotatingBanner === 'prize') {
    return <NewbuildingPrizeBannerContainer />;
  }

  if (rotatingBanner === 'broker') {
    return <BrokerConsultantBannerContainer />;
  }

  return null;
};
